import * as api from '../services/api';
import Notification from '../../components/partials/header-parts/Notification';
import { mixinz } from '../global/mixinz';

export default {
  mixins: [mixinz],
  data() {
    return {
      languages: {},
      campuses: [],
      campusList: {},
      selectedLanguage: '',
      selectedCampusId: 0,
    };
  },
  components: {
    notification: Notification,
  },
  methods: {
    sidebarToggle() {
    },

    logout: () => {
      window.location = '#/Logout';
    },

    changePassword() {
      $('#change_password_modal').modal({
        show: true,
        backdrop: 'static',
      });
    },

    setSelectedCampus(value) {
      const self = this;
      if (self.selectedCampusId !== value) {
        self.selectedCampusId = value;
        if (value) {
          localStorage.setItem('campus-id', self.campusList[value].Id);
          localStorage.setItem('district-id', self.campusList[value].DistrictId);
          localStorage.setItem('city-id', self.campusList[value].CityId);
          localStorage.setItem('country-id', self.campusList[value].CountryId);
          localStorage.setItem('continent-id', self.campusList[value].ContinentId);
        } else {
          localStorage.removeItem('campus-id');
          localStorage.removeItem('district-id');
          localStorage.removeItem('city-id');
          localStorage.removeItem('country-id');
          localStorage.removeItem('continent-id');
        }
      }
    },

    toggleFullScreen() {
      this.$eventHub.$emit('toggleFullScreen');
    },
  },

  mounted() {
    const self = this;
    api.getLanguages().then((response) => {
      self.languages = response.body;
    });
    this.selectedLanguage = localStorage.getItem('vue-lang');

    api.getCampusWithParents().then((response) => {
      response.body.forEach((campus) => {
        self.campusList[campus.Id] = campus;
      });
      self.campuses = response.body.map((x) => ({ Text: x.Name, Value: x.Id }));
    });

    this.selectedCampusId = localStorage.getItem('campus-id');

    $("#m_header_nav [name='language']").on('change', (e) => {
      const { value } = e.target;
      if (value) {
        localStorage.setItem('vue-lang', value);
        const path = self.$router.history.current.fullPath;
        self.$router.push({ path: '/404' });
        self.$nextTick(() => {
          self.$router.replace({ path });
          // #758 no'lu bug dolayısıyla kapatıldı.
          // TODO : Eren - sorunu çözmek lazım kapatmak değil.
          // self.$router.go({path: path,force:true});
          self.$router.go();
        });
      }
    });
  },
  computed: {
    userName() {
      return localStorage.getItem('userName');
    },
    eMail() {
      return localStorage.getItem('eMail');
    },
  },
};
